import { useState } from 'react';
import './App.css';
import Header from './pages/Header';
import Describe from './pages/Describe';
import About from './pages/About';
import CoreService from './pages/CoreService';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Footer from './pages/Footer';

function App() {




  return (
    <>
        <Header />
        <Describe />
        <About />
        <CoreService />
        <Projects />
        <Contact />
        <Footer />
    
    </>
  );
}

export default App;
